import {
    SET_CITY_DETAILS, SET_MASTER_CITIES, SET_BOARDING_POINTS_LOCATIONS, SET_DROP_POINTS_LOCATIONS
} from '../actions/action-types';

import { sortJsonObject } from './../utils/utilities'

const initialState = {
    cities: [],
    masterCities: [],
    boardingAddressLocations: [],
    dropAddressLocations: [],
}

export const cityReducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {

        case SET_CITY_DETAILS:
            newState["cities"] = action.payload.cities;
            return newState;

        case SET_MASTER_CITIES:
            newState['masterCities'] = action.payload;
            return newState;

        case SET_DROP_POINTS_LOCATIONS: {
            newState["dropAddressLocations"] = sortJsonObject(action.payload.addressLocations, 'name', false);
            return newState;
        }

        case SET_BOARDING_POINTS_LOCATIONS: {
            newState["boardingAddressLocations"] = sortJsonObject(action.payload.addressLocations, 'name', false);
            return newState;
        }

        default:
            return state;
    }
}